import { z } from "zod";

const translationPath = "page.4uBus.uBusAutomationRobot.errors.";

const examMachineModalitySchema = z.object(
  {
    id: z.string(),
    name: z.string().optional().nullable(),
    code: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "examMachineModality" },
);

const examMachineSchema = z.object(
  {
    id: z.string(),
    name: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "exam_machine" },
);

const _4uBusAutomationSchema = z.object(
  {
    id: z.string(),
    name: z.string().optional().nullable(),
    code: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "uBusAutomation" },
);
const softwareSchema = z.object(
  {
    id: z.string(),
    name: z.string().optional().nullable(),
    code: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "software" },
);

const integrationAttributeSchema = z.object(
  {
    id: z.string(),
    name: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "integration_attribute" },
);

const uBusAutomationExecutionSchema = z.object(
  {
    id: z.string(),
    softwareId: z.string().optional().nullable(),
    name: z.string().optional().nullable(),
    code: z.number().optional().nullable(),
  },
  { invalid_type_error: translationPath + "uBusAutomationExecution" },
);

const genericSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

export const fileIntegrationSchema = z
  .object({
    id: z.string().optional(),
    name: z
      .string()
      .trim()
      .min(1, translationPath + "name"),
    enable: z.boolean(),
    path: z
      .string()
      .trim()
      .min(1, translationPath + "path"),
    pathSeparator: z.string().nullish(),
    internalProcedureIntegrationId: z.string().nullish(),
    medicalCertificateContent: z.string().nullish(),
    description: z.string().optional().nullable(),
    examMachine: examMachineSchema,
    software: softwareSchema,
    examMachineModality: examMachineModalitySchema,
    uBusAutomation: _4uBusAutomationSchema,
    generatePdfWithImages: z.boolean(),
    rotateImages: z.boolean(),
    insertReportTestPdf: z.boolean(),
    insertReportTestPdfAsImage: z.boolean(),
    insertImageAsAttachment: z.boolean(),
    physicianWillReport: z.boolean(),
    makeCopyFilesEndOfProcess: z.boolean(),
    copyFilesPath: z.string().nullish(),
    uBusAutomationExecution: uBusAutomationExecutionSchema,
    integrationAttribute: integrationAttributeSchema,
    rotationMode: genericSchema.nullish(),
    copyProcess: genericSchema.nullish(),
    renameFileProcess: genericSchema.nullish(),
    suffixPrefix: z
      .string()
      .trim()
      .max(50, translationPath + "suffixPrefix")
      .nullish(),
    identificationPosition: z.coerce.number().nullish(),
    minutes: z
      .string()
      .trim()
      .min(1, translationPath + "minutes"),
    minutesToGroupPdf: z
      .string()
      .trim()
      .min(1, translationPath + "minutes_to_group_pdf"),
    idRobotRule: z.string().optional(),
  })
  .superRefine((val, ctx) => {
    if (val.rotateImages) {
      if (!val.rotationMode) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "rotation_mode",
          path: ["rotationMode"],
        });
      }
    }
    if (val.software.code == "17" && val.uBusAutomationExecution.code == 1) {
      if (!val.internalProcedureIntegrationId) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "internal_procedure_integration_id",
          path: ["internalProcedureIntegrationId"],
        });
      }
    }
    if (val.makeCopyFilesEndOfProcess) {
      if (!val.copyFilesPath || val.copyFilesPath.trim().length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "copy_files_path",
          path: ["copyFilesPath"],
        });
      }
      if (!val.copyProcess) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: translationPath + "copy_process",
          path: ["copyProcess"],
        });
      }
    }
  });

export type TFileIntegrationForm = z.infer<typeof fileIntegrationSchema>;
